module.exports = __webpack_public_path__ + "img/student_help_post_work.4050744d.jpg";